import {DirectoryDropItem, DropItem, FileDropItem, TextDropItem} from 'react-aria'

export function isTextDropItem(dropItem: DropItem): dropItem is TextDropItem {
  return dropItem.kind === 'text' && dropItem.types.has('text/plain')
}
export function isFileDropItem(dropItem: DropItem): dropItem is FileDropItem {
  return dropItem.kind === 'file'
}
export function isDirectoryDropItem(dropItem: DropItem): dropItem is DirectoryDropItem {
  return dropItem.kind === 'directory'
}
